import {
    Checkbox, DefaultButton, Dropdown, getId, Icon, Modal, PrimaryButton, ProgressIndicator, TextField
} from "@fluentui/react";
import {
    checkboxStyles,
    defaultButtonStyles, dropdownStyles, primaryButtonStyles, textFieldStyles
} from "../../../common/views/DefaultStyles";
import ModalHeaderView from "../../../common/views/ModalHeaderView";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { SocialAccountModel } from "../../models/SocialAccountModel";
import { SocialAccountUtils } from "./SocialAccountUtils";

export type AccountEntryProps = {
    isEdit: boolean;
    form: SocialAccountModel;
    errorMessages: any;
    submitting: boolean;
    onValueChange: (field: keyof SocialAccountModel, value: any) => void;
    onSubmit: () => void;
    onClose: () => void;
}

export default function AccountEntryView({
    isEdit, form, errorMessages, submitting, onValueChange, onSubmit, onClose
}: AccountEntryProps) {
    const isMobile = window.innerWidth <= 500;
    const width6 = Utils.getColumnWidth(6);
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const nameInput = () => {
        return <>
            <TextField
                label="Name"
                value={form.name}
                onChange={(_, v) => onValueChange("name", v || "")}
                errorMessage={errorMessages.name}
                styles={textFieldStyles} />
        </>;
    }

    const urlInput = () => {
        return <>
            <TextField
                label="URL"
                value={form.url}
                onChange={(_, v) => onValueChange("url", v || "")}
                errorMessage={errorMessages.url}
                styles={textFieldStyles} />
        </>;
    }

    const typePicker = () => {
        return <>
            <Dropdown
                label="Type"
                selectedKey={form.type}
                options={SocialAccountUtils.getTypeOptions()}
                styles={dropdownStyles}
                onChange={(_, v) => onValueChange("type", v?.key || 0)} />
        </>;
    }

    const isPrimaryCheckbox = () => {
        return <>
            <Checkbox
                label="Set Default?"
                checked={form.isPrimary}
                onChange={(_, v) => onValueChange("isPrimary", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row">
            <div className={width6}>
                <DefaultButton
                    onClick={onClose}
                    styles={defaultButtonStyles}
                >Cancel</DefaultButton>
            </div>
            <div className={width6 + " right"}>
                <PrimaryButton
                    onClick={onSubmit}
                    styles={primaryButtonStyles}
                >Submit</PrimaryButton>
            </div>
        </div>;
    }

    const modalHeader = () => {
        const title = isEdit ? "Edit Social Account: " + form.id : "Add New Social Account";

        return <>
            <ModalHeaderView title={title} onClose={onClose} />
        </>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={true}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            {modalHeader()}

            <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body ph-15"}>
                <div>{nameInput()}</div>
                <div className="pt-15">{urlInput()}</div>
                <div className="pt-15">{typePicker()}</div>
                <div className="pt-15">{isPrimaryCheckbox()}</div>

                {!submitting && <div className="pv-20">{buttons()}</div>}

                {submitting && <div className="pv-20">
                    <ProgressIndicator label="Submitting" description="" />
                </div>}
            </div>
        </Modal>
    </>;
}